import React from 'react';
import Modal from '../../Modal/Modal';
import RadioButtonGroup from '../../RadioButtonGroup/RadioButtonGroup';
import { insertAtPositionOptions } from './InsertAtPositionModal.Helper';
import SelectSearch, { SelectSearchOption } from 'react-select-search';
import FormGroup from '../../FormGroup/FormGroup';
import SelectList from '../../SelectList/SelectList';
import SelectOption from '../../../../infrastructure/types/SelectOption';
import ModalStateBase from '../../Modal/ModalStateBase';

interface InsertAtPositionModalProps {
    title: string,
    dropdownOptions?: SelectSearchOption[],
    dropdownForTypeName?: string,
    defaultDropdownOption?: SelectSearchOption,
    defaultDropdownOptionAlwaysLastOne: boolean,
    dataTypeOptions?: SelectOption[],
    defaultDataType?: string,
    value?: string;
    name: string;
    onSaveClick: (name: string, type: string, insertAfter: boolean, selectedDropdownNumber: string) => void;
    onClose: () => void;
    validateFunction?: (number: number, isInsertAfter: boolean) => Promise<string>;
    component?: JSX.Element | null;
    error?: string;
    onChangeDataType?: (type: string) => void;
    isDataTypeSelectionDisabled?: boolean;
    isInsertAtpositionDisabled?: boolean;
    showNameAndType?: boolean;
    onInsertComponentChange?: () => void;
    additionalContent?: React.ReactNode;
}

class InsertAtPositionModal extends React.Component<InsertAtPositionModalProps, {
    title: string,
    isOpen: boolean,
    error: string,
    close: boolean,
    selectedDataType: string,
    insertAtPositionValue: string,
    selectedDropdownName: string,
    selectedDropdownNumber: string,
    name: string
}> {

    constructor(props: InsertAtPositionModalProps) {
        super(props);

        this.state = {
            close: false,
            title: this.props.title || '',
            error: '',
            isOpen: true,
            name: '',
            selectedDataType: this.props.defaultDataType || '',
            insertAtPositionValue: 'Insert After',
            selectedDropdownName: '',
            selectedDropdownNumber: ''
        }

        this.onInsertAtPositionChange = this.onInsertAtPositionChange.bind(this);
        this.onDropdownOptionChange = this.onDropdownOptionChange.bind(this);
        this.onNameChange = this.onNameChange.bind(this);
        this.onChangeDataType = this.onChangeDataType.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
    }

    componentDidMount() {
        if (this.props.defaultDropdownOptionAlwaysLastOne && this.props.dropdownOptions) {
            this.setState({
                selectedDropdownNumber: this.props.dropdownOptions[this.props.dropdownOptions.length - 1]?.items?.[0].value || '0',
                selectedDropdownName: this.props.dropdownOptions?.[this.props.dropdownOptions.length - 1]?.name || '',
                error: ''
            });
        }
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.error !== this.props.error) {
            this.setState({ error: this.props.error as string });
        }
    }

    onInsertAtPositionChange(value: string) {
        this.setState({ insertAtPositionValue: value, error: '' });
        this.props.onInsertComponentChange && this.props.onInsertComponentChange();
    }

    getDropdownOptions() {
        return ['Insert Before', 'Insert After'];
    }

    onDropdownOptionChange(value: any, selectedOption: any) {
        this.setState({ selectedDropdownName: value, selectedDropdownNumber: selectedOption.items[0].value, error: '' });
        this.props.onInsertComponentChange && this.props.onInsertComponentChange();
    }

    async onSaveClick() {
        if (!this.state.error) {
            const insertAfter = this.state.insertAtPositionValue === 'Insert After';

            let error = '';
            if (this.props.validateFunction) {
                error = await this.props.validateFunction(parseInt(this.state.selectedDropdownNumber), insertAfter);
            }
            if (!error) {
                this.props.onSaveClick(this.state.name, this.state.selectedDataType, insertAfter, this.state.selectedDropdownNumber);
            }
            else {
                this.setState({ error });
            }
        }
    }

    onNameChange(e: React.ChangeEvent<HTMLInputElement>) {

        var variableName = e.currentTarget.value;
        var nameExists = this.props.dropdownOptions?.find(v => v.name === variableName);
        if (!nameExists) {
            this.setState({ name: e.currentTarget.value, error: '' });
        }
        else {
            this.setState({ error: 'The name must be unique' });
        }
    }

    onChangeDataType(type: string) {

        if (this.props.onChangeDataType) {
            this.props.onChangeDataType(type);
        }

        this.setState({ selectedDataType: type, error: '' });
    }

    render(): JSX.Element {
        let modalState = this.state as ModalStateBase;

        modalState.error = this.props.error || this.state.error;

        return (
            <Modal state={modalState} close={this.props.onClose} >
                {this.props.component && this.props.component}
                {this.props.showNameAndType &&
                    < div className='display-flex align-center justify-content-start margin-bottom-20px' >
                        <FormGroup
                            label={this.props.name + ' Name'}
                            isVertical={true}
                            labelClassName='font-robotoBold'
                            contentClassName=''
                            style={{ 'display': 'flex', 'flexDirection': 'column' }}
                        >
                            <input
                                className='form-control'
                                type='text'
                                placeholder='Type here'
                                onChange={this.onNameChange}
                            />
                        </FormGroup>

                        {
                            this.props.dataTypeOptions ?
                                <FormGroup
                                    label={this.props.dropdownForTypeName as string}
                                    isVertical={true}
                                    labelClassName='font-robotoBold'
                                    contentClassName='display-flex height-100-percents align-items-start'
                                    style={{ 'display': 'flex', 'flexDirection': 'column', 'marginLeft': '50px' }}
                                >
                                    <SelectList
                                        disabled={this.props.isDataTypeSelectionDisabled}
                                        className="inline-select"
                                        options={this.props.dataTypeOptions}
                                        value={this.props.isDataTypeSelectionDisabled ? this.props.defaultDataType as string : this.state.selectedDataType}
                                        onChange={this.onChangeDataType}
                                    />
                                </FormGroup>
                                : null
                        }
                    </div>
                }
                {this.props.additionalContent}
                {!this.props.isInsertAtpositionDisabled &&
                    <div className='margin-top-20px labels-display-inline-flex'>
                        <RadioButtonGroup
                            options={insertAtPositionOptions}
                            value={this.state.insertAtPositionValue}
                            name={this.props.name}
                            onChange={this.onInsertAtPositionChange}
                            labelClassName='display-inline-flex font-robotoBold'
                        />
                    </div>
                }
                {
                    this.props.dropdownOptions &&
                    <div>
                        <SelectSearch
                            options={this.props.dropdownOptions}
                            onChange={this.onDropdownOptionChange}
                            search={true}
                            value={this.state.selectedDropdownName}
                        />
                    </div>
                }

                <div className='margin-top-20px'>
                    <button className='btn cb-btn' onClick={this.onSaveClick} >Save</button>
                </div>
            </Modal >
        )
    }
}

export default InsertAtPositionModal;
